import { render, staticRenderFns } from "./VersionTable.vue?vue&type=template&id=81a4d7b4"
import script from "./VersionTable.vue?vue&type=script&lang=js"
export * from "./VersionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports